/**
 * Indique si les sous questions doivent être mis à plat dans les AnswerPart ("FLAT") ou si elles doivent être dans le champ "subItems" de answerPart
 */
export enum AnswerPartsMode {
  FLAT,
  DEEP,
}
